const FeaturesPt1 = [
  (count: string) => ({
    mobile: `دسترسی به همه آموزش‌های این صفحه و ${count}+ آموزش دیگر  `,
    normal: `دسترسی به همه ${count}+ آموزش فرادرس`,
  }),
  "۲۰۰٬۰۰۰+ تمرین و پرسش همراه با پاسخ برای یادگیری بهتر",
  "دریافت گواهینامه در ۴٬۰۰۰+ آموزش",
];

const FeaturesPt1V2 = [
  (count: string) => ({
    mobile: `دسترسی به این آموزش و همه ${count}+ آموزش فرادرس`,
    normal: `دسترسی به همه ${count}+ آموزش فرادرس`,
  }),
  "۲۰۰٬۰۰۰+ تمرین و سوال همراه با پاسخ",
  "دریافت گواهینامه در ۴٬۰۰۰+ آموزش",
];

const FeaturesPt1V3 = [
  (count: string) => ({
    mobile: `دسترسی به آموزش‌های این صفحه و ${count}+ آموزش دیگر  `,
    normal: `دسترسی به همه ${count}+ آموزش فرادرس`,
  }),
  "۲۰۰٬۰۰۰+ تمرین و پرسش همراه با پاسخ برای یادگیری بهتر",
  "دریافت گواهینامه در ۴٬۰۰۰+ آموزش",
];

const FeaturesPt2 = [
  "دسترسی به ۵۰۰+ حوزه تخصصی",
  "دسترسی به آموزش‌های جدید پس از انتشار در فرادرس",
  "دسترسی به فایل‌ و پروژه‌ آموزش‌ها",
  "تالار پرسش و پاسخ",
];

export const SUBSCRIPTION_FEATURES = {
  program: {
    title: {
      mobile: (count: string) => `${count}+ آموزش، همه با یک اشتراک`,
      desktop: (
        count: string
      ) => `دسترسی به آموزش‌های این صفحه و ${count}+ آموزش دیگر،
            تنها با یک اشتراک`,
    },
    part_one: FeaturesPt1,
    part_two: FeaturesPt2,
  },
  product: {
    title: {
      mobile: (count: string) => `${count}+ آموزش، همه با یک اشتراک`,
      desktop: (
        count: string
      ) => `دسترسی به این آموزش و همه ${count}+ آموزش دیگر فرادرس،
            تنها با یک اشتراک`,
      free: (count: string) =>
        `دسترسی به همه ${count}+ آموزش فرادرس، تنها با یک اشتراک`,
    },
    part_one: FeaturesPt1V2,
    part_two: FeaturesPt2,
  },
  howToLearn: {
    title: {
      mobile: (count: string) => `${count}+ آموزش، همه با یک اشتراک`,
      desktop: (
        count: string
      ) => `دسترسی به آموزش‌های این صفحه و ${count}+ آموزش دیگر،
            تنها با یک اشتراک`,
    },
    part_one: FeaturesPt1V3,
    part_two: FeaturesPt2,
  },
} as const;

export const SUBSCRIPTION_PAGE_ACCESSES = {
  desktop: [
    [
      "دریافت گواهینامه در ۴٬۰۰۰+ آموزش",
      "دسترسی به فایل‌ و پروژه‌ آموزش‌ها",
      "دسترسی به آموزش‌های جدید پس از انتشار",
      "تالار پرسش و پاسخ",
    ],
    [
      (count: string) => `دسترسی به همه ${count}+ آموزش فرادرس`,
      "دسترسی به ۵۰۰+ حوزه تخصصی",
      "۲۰۰٬۰۰۰+ تمرین و سوال همراه با پاسخ",
    ],
  ],
  mobile: [
    (count: string) => `دسترسی به بیش از ${count} آموزش`,
    "دسترسی به بیش از ۵۰۰ حوزه تخصصی",
    "۲۰۰٬۰۰۰+ تمرین و سوال همراه با پاسخ",
    "دریافت گواهینامه در بیش از ۴٬۰۰۰ آموزش",
    "دسترسی به آموزش‌های جدید آینده، پس از انتشار",
    "دسترسی به فایل اسلاید و پروژه‌ها",
    "تالار پرسش و پاسخ",
  ],
};
